import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Box, Media, VerticalSpacing } from '../../../../components/Boneyard';

const propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  reduceVerticalSpacing: PropTypes.bool.isRequired,
};

const FlightDetailsWrapper = ({ theme, children, reduceVerticalSpacing }) => {
  return (
    <Media>
      {mq => (
        <Box>
          <Box d={'flex'}>{children}</Box>
          {mq.lt('md') ? (
            <VerticalSpacing size={4} />
          ) : (
            <>
              <VerticalSpacing size={mq.lt('md') ? 4 : 6} />
              <hr
                size={6}
                color={theme.colors.flights.flightDetails.dividerYellow}
              />
              <VerticalSpacing
                size={mq.lt('md') ? 4 : reduceVerticalSpacing ? 2 : 6}
              />
            </>
          )}
        </Box>
      )}
    </Media>
  );
};
FlightDetailsWrapper.propTypes = propTypes;
FlightDetailsWrapper.displayName = 'FlightDetailsWrapper';

export default withTheme(FlightDetailsWrapper);
